import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoaderService {
  loaderSubject = new BehaviorSubject<boolean>(false);
  watchLoader = this.loaderSubject.asObservable();
  showLoader = false;

  constructor() {}
}
